<template>
  <div class="modal-dialog">
    <div class="modal_content">
      <!-- contents -->
      <div class="modal_header">
        <h5>
            NCP Console
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')" />
      </div>
      <div class="modal_body">
        <div class="dp_flex full">
          <div class="dp_block line">
            <div class="fx_form_wrap full">
              <div class="com_head">
                <!-- <h4>Project Name</h4> -->
                <h4>Account ID</h4>
              </div>
              <div class="fx_form icon fx_none">
                <input type="text" v-model="searchParam.accountId" @keyup.enter="getDomainList">
                <button class="btn ico_search" type="button" @click="getDomainList"/>
              </div>
              <div class="fx_list">
                <ul>
                  <li v-for="item in listData" :key="item.accountId" @click="onSelect($event, item)" :class="[activeElement === item.accountId ? 'selected' : '']">
                    {{ item.accountId }}
                  </li>
                  <li v-show="listData.length === 0" style="text-align:center">
                    {{ $t('sdl.common.message.noResult') }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal_footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">
          {{ $t('Dismiss') }}
        </button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="moveNcp()">
          {{ $t('Login') }}
        </button>
      </div>
      <!-- // contents -->
    </div>
  </div>
</template>

<script>

import _ from 'lodash';
import SDLLocale from '@/mixin/SDLLocale';
import RemCommon from '@/mixin/RemCommon';
import { SDLUtil, RequestUtil, StringUtil } from '@/utils';

export default {
  data() {
    return {
      radioValues : 'dev',
      selectedEnv : '',
      searchParam: {accountId: ''},
      listData: [],
      activeElement : null,
    };
  },
  props: {
    rtnFunc: {
      type: Function,
    },
  },
  computed: {
    _() {
      return _;
    },
  },
  mixins: [SDLLocale, RemCommon, SDLUtil, RequestUtil, StringUtil],
  methods: {
    initData() {
      this.getDomainList();
    },
    onSelect(event, item) {
      this.activeElement = item.accountId;
      this.searchParam.domainUrl = item.domainUrl;
      // SDLUtil.alert(item.domainUrl);
    },
    moveNcp() {
      if (_.isEmpty(this.activeElement)) {
        SDLUtil.alert(this.$t('cop.coa.roles.account.notSelected'));
        return;
      }

      if (_.isEmpty(this.searchParam.domainUrl)) {
        SDLUtil.alert(this.$t('cop.coa.roles.account.url.isNotSet'));
        return;
      }

      window.open(this.searchParam.domainUrl.startsWith('http') ? this.searchParam.domainUrl : `http://${this.searchParam.domainUrl}`, '_blank');
      this.rtnFunc();

      this.$nextTick(() => this.$emit('close'));
    },
    async getDomainList() {
      const param = {
        ...this.searchParam
      };

      // const data = await RequestUtil.get(`${SDLUtil.API_URL}/cop/coa/roles/selectDomainUrlNcp?${StringUtil.queryStringfy(param)}`);
      // this.listData = data.data;
      await this.fetchGet(
        '/cop/coa/roles/selectDomainUrlNcp', {
          ...this.searchParam
        },
        res => {
          this.listData = res;
        },
        () => {},
      );
    },
  },
  created() {
    this.initData();
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/view/admin/main/NcpRolePopup.vue